module.exports = __webpack_public_path__ + "img/news2.4ea37826.svg";